// utils/payload.js
const splitFechaHora = (fechaHoraStr) => {
  if (!fechaHoraStr) return { fecha: null, hora: null };
  const [fecha, hora] = fechaHoraStr.split("T");
  return { fecha, hora };
};

// Normaliza el subtipo de adición ("Vinculación adicional", "vinculacion-adicional"...) a "VINCULACION_ADICIONAL".
export const normTipoAdicion = (tipoAdicion) =>
  String(tipoAdicion || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, "_");

// La adición de equipo nuevo (3), el mantenimiento (2) y la devolución (5) ya no pasan por
// Programación: se emiten directo en Trabajo de campo (3) y los equipos se asignan / devuelven allí
// mismo. La vinculación adicional y la devolución con transferencia de cliente empiezan en 2.
export const estadoInicial = (tipoRequerimiento, tipoAdicion, esTransferenciaCliente = false) => {
  const tipo = String(tipoRequerimiento);
  if (tipo === "3" && normTipoAdicion(tipoAdicion) !== "VINCULACION_ADICIONAL") return 3;
  if (tipo === "5" && !esTransferenciaCliente) return 3;
  if (tipo === "2") return 3;
  return 2;
};

export const buildPayload = ({
  tipo_requerimiento,
  tipo_adicion,
  cod_servicio_cliente,
  sucursal,
  contacto,
  telefono,
  descripcion,
  fechaHora,   // 'YYYY-MM-DDTHH:mm'
  lugar,
  placas,      // array de strings
  tecnicos,    // array de usernames
  tercia,
  usu,
  solicitante,
  es_transferencia_cliente,
  cod_servicio_destino,
}) => {
  const { fecha, hora } = splitFechaHora(fechaHora);
  const placaCSV = (placas && placas.length) ? placas.join(",") : "";
  const tecnicosCSV = (tecnicos && tecnicos.length) ? tecnicos.join(", ") : "";

  const cordinacion = {
    fecha: fecha || new Date().toISOString().slice(0, 10),
    hora:  hora || new Date().toTimeString().slice(0, 5),
    lugar: lugar || "",
    contacto: contacto || "",
    telefono: telefono || "",
    tecnico: tecnicosCSV,
    tecnicos: tecnicosCSV,
    placa: placaCSV,
    observacion: descripcion || "",
    gasto1: 0, gasto2: 0, gasto3: 0,
    estado: "Activo",
    obs_fin: "",
    color: "#3F51B5",
  };

  const payload = {
    tipo_req: Number(tipo_requerimiento),
    cod_servicio_cliente: Number(cod_servicio_cliente),
    sucursal: sucursal || "La Paz",
    estado: estadoInicial(tipo_requerimiento, tipo_adicion, !!es_transferencia_cliente),
    tercia: tercia,
    usu: usu || "sistema",
    solicitante: solicitante ?? (contacto || ""),
    observacion: descripcion || "",
    cordinacion,
  };

  if (tipo_adicion !== undefined && tipo_adicion !== null && String(tipo_adicion).trim() !== "") {
    payload.tipo_adicion = String(tipo_adicion).trim();
  }

  if (es_transferencia_cliente) {
    payload.es_transferencia_cliente = 1;
    payload.cod_servicio_destino = Number(cod_servicio_destino);
  }

  return payload;
};
